import Immutable from 'immutable';
import {
  CLEAR_AREAS,
  CLEAR_FDEPARTAMENTS,
  FLAG_GETTING_AREAS,
  FLAG_GETTING_DEPARTAMENTS,
  GET_AREAS,
  GET_DEPARTAMENTS,
} from '../../../actions/types/hcm/Organization';

const INITIAL_STATE = Immutable.Map({
  departaments: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
  areas: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_DEPARTAMENTS:
      return state.setIn(['departaments', 'loading'], payload);

    case GET_DEPARTAMENTS:
      return state.setIn(
        ['departaments', 'content'],
        Immutable.fromJS(payload || []),
      );

    case CLEAR_FDEPARTAMENTS:
      return state.setIn(
        ['departaments', 'content'],
        INITIAL_STATE.getIn(['departaments', 'content']),
      );

    case FLAG_GETTING_AREAS:
      return state.setIn(['areas', 'loading'], payload);

    case GET_AREAS:
      return state.setIn(['areas', 'content'], Immutable.fromJS(payload || []));

    case CLEAR_AREAS:
      return state.setIn(
        ['areas', 'content'],
        INITIAL_STATE.getIn(['areas', 'content']),
      );

    default:
      return state;
  }
};
